import { Loading, ShowContextProvider, ShowControllerProps, useShowController } from 'react-admin'
import { BlogAuthor } from '../../components/domains/blogs/BlogAuthor'
import { BlogTitle } from '../../components/domains/blogs/BlogTitle'
import { BlogImgHeader } from '../../components/domains/blogs/BlogImgHeader'
import { BlogContent } from '../../components/domains/blogs/BlogContent'
// import BlogAttachment from '../../components/domains/blogs/BlogAttachment'
import BlogImages from '../../components/domains/blogs/BlogImages'
import { Card, Container, Stack, styled } from '@mui/material'
import { useRouteExtract } from '../../hooks/useRouteExtract'
import { useMemo } from 'react'
import config from '../../config'
import ModifyTimeStamp from '../../components/ModifyTimeStamp'

const StackStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4, 2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 10),
  },
}))

const CardPreview = styled(Card)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    borderRadius: 0,
    boxShadow: 'none',
  },
}))

const ContainerStyled = styled(Container)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    padding: 0,
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(12, 0),
  },
}))

const langSupports = config('langSupports')

export const BlogPreview: React.FC = () => {
    const { pathSegments, queryParams } = useRouteExtract()
    const lang = queryParams['lang']
    const langActive = useMemo(() => (langSupports.includes(lang) ? lang : 'th'), [lang])
  const [resourceName, newId] = pathSegments
  const showProps: ShowControllerProps = {
    disableAuthentication: true,
    id: newId,
    resource: resourceName,
  }
  const showController = useShowController(showProps)
  const { isLoading } = showController

  if (isLoading) return <Loading />

  return (
    <ShowContextProvider value={showController}>
      <ContainerStyled maxWidth='md'>
        <CardPreview elevation={0}>
          <BlogImgHeader source='cover.full_path' />
          <StackStyled spacing={1}>
            <ModifyTimeStamp language={`${langActive}`} />
            <BlogTitle source={`title_${langActive}`} />
            <BlogAuthor authorSource='create_by' dateSource='create_at' />
            <BlogContent source={`description_${langActive}`} />
            <BlogImages source='images' title='name' />
            {/* <BlogAttachment source='files.full_path' title='name' /> */}
          </StackStyled>
        </CardPreview>
      </ContainerStyled>
    </ShowContextProvider>
  )
}

export default BlogPreview
